<template>
	<div class="user-center-container">
		<!-- 页面头部 -->
		<div class="page-header">
			<div class="header-content">
				<div class="header-icon">
					<svg class="icon" viewBox="0 0 24 24">
						<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
					</svg>
				</div>
				<div class="header-text">
					<h1 class="page-title">个人中心</h1>
					<p class="page-description">管理您的个人信息和账户设置</p>
				</div>
			</div>
		</div>

		<!-- 用户资料卡片 -->
		<div class="profile-overview" v-if="flag=='yonghu'">
			<div class="profile-card">
				<div class="profile-avatar">
					<div class="avatar-wrapper">
						<img 
							v-if="ruleForm.touxiang" 
							:src="getAvatarUrl(ruleForm.touxiang)" 
							alt="用户头像"
							class="avatar-image"
						>
						<div v-else class="avatar-placeholder">
							<svg class="placeholder-icon" viewBox="0 0 24 24">
								<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
							</svg>
						</div>
					</div>
				</div>
				<div class="profile-info">
					<h3 class="user-name">{{ ruleForm.yonghuxingming || '未设置姓名' }}</h3>
					<p class="user-account">@{{ ruleForm.yonghuzhanghao }}</p>
					<div class="user-badges">
						<span class="badge user-badge">
							<i class="el-icon-user"></i>
							用户
						</span>
						<span class="badge gender-badge" v-if="ruleForm.xingbie">
							<i :class="ruleForm.xingbie === '男' ? 'el-icon-male' : 'el-icon-female'"></i>
							{{ ruleForm.xingbie }}
						</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 编辑表单 -->
		<div class="form-container">
			<el-form
				ref="ruleForm"
				:model="ruleForm"
				label-width="120px"
				class="user-form"
			>
				<!-- 用户信息部分 -->
				<div class="form-section" v-if="flag=='yonghu'">
					<h3 class="section-title">基本信息</h3>
					
					<el-form-item label="用户账号" prop="yonghuzhanghao" class="form-item">
						<div class="input-wrapper">
							<div class="input-field readonly">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.yonghuzhanghao" 
									readonly 
									placeholder="用户账号"
									class="form-input"
								></el-input>
								<div class="readonly-indicator">
									<svg class="lock-icon" viewBox="0 0 24 24">
										<path d="M18,8H17V6A5,5 0 0,0 7,6V8H6A2,2 0 0,0 4,10V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V10A2,2 0 0,0 18,8M12,17A2,2 0 0,1 10,15A2,2 0 0,1 12,13A2,2 0 0,1 14,15A2,2 0 0,1 12,17M15.8,8H8.2V6A3.8,3.8 0 0,1 12,2.2A3.8,3.8 0 0,1 15.8,6V8Z"/>
									</svg>
								</div>
							</div>
							<span class="field-tip">账号不可修改</span>
						</div>
					</el-form-item>

					<el-form-item label="用户姓名" prop="yonghuxingming" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.yonghuxingming" 
									placeholder="请输入您的真实姓名"
									class="form-input"
									clearable
								></el-input>
							</div>
						</div>
					</el-form-item>

					<el-form-item label="性别" prop="xingbie" class="form-item">
						<div class="input-wrapper">
							<div class="gender-selector">
								<div 
									v-for="(option, index) in yonghuxingbieOptions" 
									:key="index"
									class="gender-option"
									:class="{ 'active': ruleForm.xingbie === option }"
									@click="selectGender(option)"
								>
									<div class="gender-icon">
										<svg v-if="option === '男'" viewBox="0 0 24 24">
											<path d="M9,9C10.29,8.99 11.4,9.73 11.83,10.86C12.25,12 11.93,13.28 11,14C9.89,14.96 8.11,14.73 7.29,13.56C6.46,12.38 6.84,10.7 8.17,10.04C8.43,9.86 8.72,9.92 9,9M12,3.5L18,9.5H15V16.5H9V13.5H6L12,3.5Z"/>
										</svg>
										<svg v-else viewBox="0 0 24 24">
											<path d="M12,2A3,3 0 0,1 15,5A3,3 0 0,1 12,8A3,3 0 0,1 9,5A3,3 0 0,1 12,2M21,9V11H19V9L17,11V20A2,2 0 0,1 15,22H9A2,2 0 0,1 7,20V11L5,9V11H3V9L6,6H18L21,9Z"/>
										</svg>
									</div>
									<span class="gender-text">{{ option }}</span>
								</div>
							</div>
						</div>
					</el-form-item>

					<el-form-item label="联系方式" prop="lianxifangshi" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.lianxifangshi" 
									placeholder="请输入手机号码"
									class="form-input"
									clearable
									:class="{ 'error': contactError }"
									@blur="validateContact"
								></el-input>
								<div class="field-status">
									<svg v-if="contactValid" class="status-icon success" viewBox="0 0 24 24">
										<path d="M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z"/>
									</svg>
									<svg v-if="contactError" class="status-icon error" viewBox="0 0 24 24">
										<path d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/>
									</svg>
								</div>
							</div>
							<div v-if="contactError" class="error-tip">请输入正确的手机号码格式</div>
						</div>
					</el-form-item>
				</div>

				<!-- 头像上传部分 -->
				<div class="form-section" v-if="flag=='yonghu'">
					<h3 class="section-title">头像设置</h3>
					
					<el-form-item label="个人头像" prop="touxiang" class="form-item avatar-item">
						<div class="avatar-upload-wrapper">
							<div class="current-avatar">
								<img 
									v-if="ruleForm.touxiang" 
									:src="getAvatarUrl(ruleForm.touxiang)" 
									alt="当前头像"
									class="preview-avatar"
								>
								<div v-else class="avatar-placeholder-large">
									<svg class="placeholder-icon-large" viewBox="0 0 24 24">
										<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
									</svg>
									<p class="placeholder-text">暂无头像</p>
								</div>
							</div>
							<div class="upload-controls">
								<file-upload
									tip="点击上传头像"
									action="file/upload"
									:limit="1"
									:multiple="false"
									:fileUrls="ruleForm.touxiang?ruleForm.touxiang:''"
									@change="yonghutouxiangUploadChange"
									class="custom-upload"
								></file-upload>
								<div class="upload-tips">
									<p class="tip-text">• 支持 JPG、PNG 格式</p>
									<p class="tip-text">• 建议尺寸 200x200 像素</p>
									<p class="tip-text">• 文件大小不超过 2MB</p>
								</div>
							</div>
						</div>
					</el-form-item>
				</div>

				<!-- 管理员用户名部分 -->
				<div class="form-section" v-if="flag=='users'">
					<h3 class="section-title">账户信息</h3>
					
					<el-form-item label="用户名" prop="username" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<svg class="field-icon" viewBox="0 0 24 24">
									<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
								</svg>
								<el-input 
									v-model="ruleForm.username" 
									placeholder="请输入用户名"
									class="form-input"
									clearable
								></el-input>
							</div>
						</div>
					</el-form-item>
				</div>

				<!-- 操作按钮 -->
				<div class="form-actions">
					<el-button 
						type="primary" 
						@click="onUpdateHandler"
						:loading="updateLoading"
						class="submit-btn"
					>
						<i class="el-icon-check"></i>
						{{ updateLoading ? '保存中...' : '保存修改' }}
					</el-button>
					<el-button @click="resetForm" class="reset-btn">
						<i class="el-icon-refresh-left"></i>
						重置
					</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber,isIntNumer,isEmail,isMobile,isPhone,isURL,checkIdCard } from "@/utils/validate";

export default {
	data() {
		return {
			ruleForm: {},
			originalForm: {}, // 用于重置表单
			flag: '',
			usersFlag: false,
			updateLoading: false,
			contactError: false,
			contactValid: false,
			yonghuxingbieOptions: [],
		};
	},

	mounted() {
		var table = this.$storage.get("sessionTable");
		this.flag = table;
		this.loadUserData();
		this.yonghuxingbieOptions = "男,女".split(',');
	},

	methods: {
		// 加载用户数据
		loadUserData() {
			this.$http({
				url: `${this.$storage.get("sessionTable")}/session`,
				method: "get"
			}).then(({ data }) => {
				if (data && data.code === 0) {
					this.ruleForm = data.data;
					// 保存原始数据用于重置
					this.originalForm = JSON.parse(JSON.stringify(data.data));
				} else {
					this.$message.error(data.msg);
				}
			});
		},

		// 获取头像URL
		getAvatarUrl(avatar) {
			if (!avatar) return '';
			if (avatar.startsWith('http')) {
				return avatar;
			}
			return this.$base.url + avatar;
		},

		// 选择性别
		selectGender(gender) {
			this.ruleForm.xingbie = gender;
		},

		// 验证联系方式
		validateContact() {
			if (this.ruleForm.lianxifangshi) {
				this.contactError = !isMobile(this.ruleForm.lianxifangshi);
				this.contactValid = isMobile(this.ruleForm.lianxifangshi);
			} else {
				this.contactError = false;
				this.contactValid = false;
			}
		},

		// 重置表单
		resetForm() {
			this.ruleForm = JSON.parse(JSON.stringify(this.originalForm));
			this.contactError = false;
			this.contactValid = false;
		},

		// 头像上传改变 (保持原有逻辑)
		yonghutouxiangUploadChange(fileUrls) {
			this.ruleForm.touxiang = fileUrls;
		},

		// 更新处理 (保持原有逻辑)
		onUpdateHandler() {
			if((!this.ruleForm.mima)&& 'yonghu'==this.flag){
				this.$message.error('密码不能为空');
				return
			}

			if(this.ruleForm.touxiang!=null) {
				this.ruleForm.touxiang = this.ruleForm.touxiang.replace(new RegExp(this.$base.url,"g"),"");
			}

			if( 'yonghu' ==this.flag && this.ruleForm.lianxifangshi&&(!isMobile(this.ruleForm.lianxifangshi))){
				this.$message.error(`联系方式应输入手机格式`);
				return
			}

			if( 'yonghu' ==this.flag && this.ruleForm.money&&(!isNumber(this.ruleForm.money))){
				this.$message.error(`余额应输入数字`);
				return
			}

			if('users'==this.flag && this.ruleForm.username.trim().length<1) {
				this.$message.error(`用户名不能为空`);
				return	
			}

			this.updateLoading = true;

			this.$http({
				url: `${this.$storage.get("sessionTable")}/update`,
				method: "post",
				data: this.ruleForm
			}).then(({ data }) => {
				this.updateLoading = false;
				if (data && data.code === 0) {
					this.$message({
						message: "修改信息成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							// 更新原始数据
							this.originalForm = JSON.parse(JSON.stringify(this.ruleForm));
						}
					});
				} else {
					this.$message.error(data.msg);
				}
			}).catch(() => {
				this.updateLoading = false;
				this.$message.error("网络错误，请稍后重试");
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.user-center-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		gap: 16px;
		background: white;
		padding: 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-icon {
			width: 56px;
			height: 56px;
			background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
			border-radius: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);

			.icon {
				width: 24px;
				height: 24px;
				fill: white;
			}
		}

		.header-text {
			flex: 1;

			.page-title {
				font-size: 24px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 4px 0;
			}

			.page-description {
				color: #64748b;
				font-size: 14px;
				margin: 0;
			}
		}
	}
}

// 用户资料概览
.profile-overview {
	margin-bottom: 24px;

	.profile-card {
		background: white;
		border-radius: 8px;
		padding: 24px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		display: flex;
		align-items: center;
		gap: 20px;

		.profile-avatar {
			.avatar-wrapper {
				width: 80px;
				height: 80px;
				border-radius: 50%;
				overflow: hidden;
				position: relative;
				background: #f1f5f9;
				border: 3px solid #e2e8f0;

				.avatar-image {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}

				.avatar-placeholder {
					width: 100%;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);

					.placeholder-icon {
						width: 32px;
						height: 32px;
						fill: #94a3b8;
					}
				}
			}
		}

		.profile-info {
			flex: 1;

			.user-name {
				font-size: 20px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 4px 0;
			}

			.user-account {
				color: #64748b;
				font-size: 14px;
				margin: 0 0 12px 0;
			}

			.user-badges {
				display: flex;
				gap: 8px;

				.badge {
					display: inline-flex;
					align-items: center;
					gap: 4px;
					padding: 4px 8px;
					border-radius: 4px;
					font-size: 12px;
					font-weight: 500;

					&.user-badge {
						background: #dbeafe;
						color: #1d4ed8;
					}

					&.gender-badge {
						background: #fef3c7;
						color: #d97706;
					}

					i {
						font-size: 12px;
					}
				}
			}
		}
	}
}

// 表单容器
.form-container {
	max-width: 800px;
	margin: 0 auto;
}

// 用户表单
.user-form {
	background: white;
	padding: 32px;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

	.form-section {
		margin-bottom: 32px;

		&:last-of-type {
			margin-bottom: 0;
		}

		.section-title {
			font-size: 18px;
			font-weight: 600;
			color: #1e293b;
			margin: 0 0 24px 0;
			padding-bottom: 8px;
			border-bottom: 2px solid #e2e8f0;
		}
	}

	// 表单项
	.form-item {
		margin-bottom: 24px;

		:deep(.el-form-item__label) {
			font-weight: 500;
			color: #374151;
			line-height: 32px;
		}

		&.avatar-item {
			:deep(.el-form-item__content) {
				line-height: 1;
			}
		}
	}

	// 输入包装器
	.input-wrapper {
		width: 100%;
	}

	// 输入字段
	.input-field {
		position: relative;
		display: flex;
		align-items: center;
		border: 1px solid #d1d5db;
		border-radius: 8px;
		transition: all 0.2s ease;
		background: #fafafa;

		&:focus-within {
			border-color: #3b82f6;
			box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
			background: white;
		}

		&.readonly {
			background: #f9fafb;
			border-color: #e5e7eb;

			&:focus-within {
				border-color: #e5e7eb;
				box-shadow: none;
			}
		}

		.field-icon {
			width: 18px;
			height: 18px;
			fill: #9ca3af;
			margin: 0 12px 0 16px;
			flex-shrink: 0;
		}

		.form-input {
			flex: 1;

			:deep(.el-input__inner) {
				border: none;
				background: transparent;
				font-size: 14px;
				padding: 12px 16px 12px 0;
				height: auto;

				&:focus {
					border: none;
					box-shadow: none;
				}

				&::placeholder {
					color: #9ca3af;
				}

				&[readonly] {
					color: #6b7280;
					cursor: default;
				}
			}
		}

		// 只读指示器
		.readonly-indicator {
			margin-right: 12px;

			.lock-icon {
				width: 14px;
				height: 14px;
				fill: #9ca3af;
			}
		}

		// 字段状态
		.field-status {
			margin-right: 12px;

			.status-icon {
				width: 16px;
				height: 16px;

				&.success {
					fill: #10b981;
				}

				&.error {
					fill: #ef4444;
				}
			}
		}
	}

	// 字段提示
	.field-tip {
		color: #6b7280;
		font-size: 12px;
		margin-top: 4px;
	}

	// 错误提示
	.error-tip {
		color: #ef4444;
		font-size: 12px;
		margin-top: 4px;
		display: flex;
		align-items: center;
		gap: 4px;
	}
}

// 性别选择器
.gender-selector {
	display: flex;
	gap: 12px;

	.gender-option {
		flex: 1;
		padding: 12px 16px;
		border: 2px solid #e5e7eb;
		border-radius: 8px;
		cursor: pointer;
		transition: all 0.2s ease;
		display: flex;
		align-items: center;
		gap: 8px;
		background: white;

		&:hover {
			border-color: #cbd5e1;
			background: #f8fafc;
		}

		&.active {
			border-color: #3b82f6;
			background: #eff6ff;
			color: #1d4ed8;

			.gender-icon svg {
				fill: #1d4ed8;
			}
		}

		.gender-icon {
			width: 20px;
			height: 20px;
			display: flex;
			align-items: center;
			justify-content: center;

			svg {
				width: 16px;
				height: 16px;
				fill: #6b7280;
				transition: fill 0.2s ease;
			}
		}

		.gender-text {
			font-size: 14px;
			font-weight: 500;
		}
	}
}

// 头像上传
.avatar-upload-wrapper {
	display: flex;
	gap: 24px;
	align-items: flex-start;

	.current-avatar {
		.preview-avatar {
			width: 120px;
			height: 120px;
			border-radius: 8px;
			object-fit: cover;
			border: 2px solid #e5e7eb;
		}

		.avatar-placeholder-large {
			width: 120px;
			height: 120px;
			border-radius: 8px;
			border: 2px dashed #cbd5e1;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			background: #f9fafb;

			.placeholder-icon-large {
				width: 32px;
				height: 32px;
				fill: #9ca3af;
				margin-bottom: 8px;
			}

			.placeholder-text {
				color: #6b7280;
				font-size: 12px;
				margin: 0;
			}
		}
	}

	.upload-controls {
		flex: 1;

		.custom-upload {
			margin-bottom: 16px;
		}

		.upload-tips {
			.tip-text {
				color: #6b7280;
				font-size: 12px;
				margin: 0 0 4px 0;
				line-height: 1.4;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
}

// 操作按钮
.form-actions {
	padding-top: 24px;
	border-top: 1px solid #e5e7eb;
	display: flex;
	gap: 12px;
	justify-content: center;

	.el-button {
		padding: 12px 32px;
		font-weight: 500;
		border-radius: 8px;
		font-size: 14px;

		i {
			margin-right: 4px;
		}
	}

	.submit-btn {
		&:disabled {
			opacity: 0.6;
			cursor: not-allowed;
		}
	}

	.reset-btn {
		color: #6b7280;
		border-color: #d1d5db;

		&:hover {
			color: #374151;
			border-color: #9ca3af;
		}
	}
}

// 文件上传组件样式覆盖
:deep(.custom-upload) {
	.el-upload {
		border: 2px dashed #cbd5e1;
		border-radius: 8px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		transition: all 0.2s ease;
		background: white;
		padding: 16px;
		text-align: center;
		min-height: 80px;
		display: flex;
		align-items: center;
		justify-content: center;

		&:hover {
			border-color: #3b82f6;
			background: #f8fafc;
		}
	}

	.el-upload-dragger {
		background: transparent;
		border: none;
		width: 100%;
		height: auto;
		min-height: auto;
		border-radius: 0;
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.user-center-container {
		padding: 20px;
	}

	.form-container {
		max-width: 100%;
	}

	.profile-overview {
		.profile-card {
			flex-direction: column;
			text-align: center;
			gap: 16px;
		}
	}

	.avatar-upload-wrapper {
		flex-direction: column;
		gap: 16px;
		align-items: center;
	}
}

@media (max-width: 768px) {
	.user-center-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			padding: 20px;

			.header-icon {
				width: 48px;
				height: 48px;

				.icon {
					width: 20px;
					height: 20px;
				}
			}

			.header-text {
				.page-title {
					font-size: 20px;
				}

				.page-description {
					font-size: 13px;
				}
			}
		}
	}

	.user-form {
		padding: 24px;

		.form-section {
			margin-bottom: 24px;

			.section-title {
				font-size: 16px;
			}
		}

		.form-item {
			margin-bottom: 20px;

			:deep(.el-form-item__label) {
				font-size: 14px;
			}
		}
	}

	.gender-selector {
		flex-direction: column;
		gap: 8px;

		.gender-option {
			justify-content: center;
		}
	}

	.form-actions {
		flex-direction: column;
		gap: 8px;

		.el-button {
			width: 100%;
		}
	}
}

@media (max-width: 480px) {
	.user-center-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			text-align: center;
			gap: 12px;
		}
	}

	.user-form {
		padding: 20px;

		.input-field {
			.field-icon {
				margin: 0 8px 0 12px;
			}

			.form-input {
				:deep(.el-input__inner) {
					font-size: 16px; // 防止移动端缩放
				}
			}
		}
	}

	.profile-overview {
		.profile-card {
			padding: 16px;

			.profile-avatar {
				.avatar-wrapper {
					width: 60px;
					height: 60px;

					.placeholder-icon {
						width: 24px;
						height: 24px;
					}
				}
			}

			.profile-info {
				.user-name {
					font-size: 18px;
				}
			}
		}
	}

	.avatar-upload-wrapper {
		.current-avatar {
			.preview-avatar,
			.avatar-placeholder-large {
				width: 100px;
				height: 100px;
			}
		}
	}
}
</style>
